var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "splideGallery",
      staticClass: "gallery__slider splide splide--gallery",
      attrs: { id: _vm.id }
    },
    [
      _c("div", { staticClass: "splide__track" }, [
        _c(
          "ul",
          { staticClass: "splide__list" },
          _vm._l(_vm.images, function(image) {
            return _c("li", { key: image.id, staticClass: "splide__slide" }, [
              _c("div", { staticClass: "splide__img-wrapper" }, [
                _c("img", { attrs: { src: image.url, alt: image.title } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "splide__body" }, [
                _c("h3", [_vm._v(_vm._s(image.title))]),
                _vm._v(" "),
                image.assetLink != ""
                  ? _c(
                      "a",
                      {
                        staticClass: "button button--primary",
                        attrs: { href: image.assetLink }
                      },
                      [_vm._v("Explore Range")]
                    )
                  : _vm._e()
              ])
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }